/**
 * Package entry — Drag the Words (ACH) content type
 */

import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    qtDragTheWordsSchema,
    defaultQtDragTheWordsConfig,
    defaultQtDragTheWordsData,
    defaultQtDragTheWordsI18n,
    normalizeQtDragTheWordsAnswerMap,
    createQtDragTheWordsItem,
    type QtDragTheWordsContent,
    type QtDragTheWordsData,
    type QtDragTheWordsConfig,
    type QtDragTheWordsLayoutConfig,
    type QtDragTheWordsItem,
    type QtDragTheWordsSplitRatio,
} from './schema';

export { normalizeQtDragTheWordsLayoutConfig } from './layout';
export {
    gradeQtDragTheWords,
    validateQtDragTheWordsContent,
    validateQtDragTheWordsAnswer,
    qtDragTheWordsContentGrader,
    countDragTheWordsQuestions,
    qtDragTheWordsQuestionCounter,
    type QtDragTheWordsItemResult,
} from './scorer';

export { DragTheWordsEdit, type DragTheWordsEditProps } from './DragTheWordsEdit';
export { DragTheWordsPlayer, type DragTheWordsPlayerProps } from './DragTheWordsPlayer';

export { qtDragTheWordsSchema as default } from './schema';
